module.exports = __webpack_public_path__ + "f81d49b71fff4c952ba1f9fb63516422.jpg";